"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/universal-cookie/cjs/types.js
 ** module id = 212
 ** module chunks = 0
 **/